<script setup>
import Card from "primevue/card";
</script>

<template>
  <div class="background">
    <div>
      <slot name="logo" />
    </div>

    <Card class="card">
      <template #content>
        <slot />
      </template>
    </Card>
  </div>
</template>

<style lang="scss" scoped>
.background {
  background-color: var(--clr-bg-primary);
  min-height: 100vh;

  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;

  padding-top: 1.5rem;

  @media (min-width: $bp-sm) {
    padding-top: 0;
  }
}

.card {
  margin-top: 1.5rem;
  overflow: hidden;
  width: 100%;

  @media (min-width: $bp-sm) {
    max-width: 32rem;
  }
}
</style>
